import type { IconSvgObject } from './types';

const LoyaltyCardIcon: IconSvgObject = [
  ["path", { d: "M20 3.5H4C2.89543 3.5 2 4.39543 2 5.5V18.5C2 19.6046 2.89543 20.5 4 20.5H20C21.1046 20.5 22 19.6046 22 18.5V5.5C22 4.39543 21.1046 3.5 20 3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.9002 11.7482C9.50317 11.0346 8.50003 12.0866 8.50003 12.0866C8.50003 12.0866 7.49684 11.0346 6.09974 11.7482C4.40759 12.6126 4.28607 15.9974 8.50003 17.5C12.714 15.9974 12.5924 12.6126 10.9002 11.7482Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 16.5H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LoyaltyCardIcon;
